export enum PasswordResetAppEnum {
    Admin = 1,
    User = 2,
}
